import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-chat-iadvize-inprocess.component.ajs.html';

const MODULE_NAME = 'agentBookingChatIadvizeInprocess';

class AgentBookingChatIadvizeInprocessCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingChatIadvizeInprocess implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingChatIadvizeInprocessCtrl];
}

export default MODULE_NAME;
